import React from 'react'
import ListComponent from '../../../../genericComponents/ListComponent'
import { CONFIG } from '../../../../config'
import { getPermissionKey } from '../../../../helper/permissions'

const CreateBoxTemplateDropdown = (props = {}) => {

    let {selectedBoxTemplate} = props || {};

    // function : to render the box template 
    const renderSkuChips = (data = {}) => {
        let ratioArray = data?.ratio?.split(',');
        return (
            <div className='flex items-center gap-3'>
                {
                    data?.sku?.split(',')?.map((s, skuIndex) => {
                        return <div className='px-1.5 py-0.5 mb-0 w-fit bg-[#E5E7EB] text-fontBlack font-medium text-[11px] flex items-center'>
                            <p className='mb-0 inline-block border-r border-black pr-[4px]'>{s || "-"}</p>
                            <p className='mb-0 pl-[4px]'>{ratioArray?.[skuIndex] || "0"}</p>
                        </div>
                    }) || "-"
                }
            </div>
        )
    }

    return (
        <div className='choose-box-template h-full w-full'>
            <ListComponent
                modalMainClass="!flex !flex-col"
                label={{
                    content: "Choose Box Template",
                }}
                closeModal={props.closeModal}
                viewDataType={"table-view"}
                headerKeys={{
                    "order_number": { "value": "PO No." },
                    "asn_type": { "value": "Shipment Packing Type" },
                    "box_count" : {"value" : "Box Count"},
                    "sku": { value: "SKU & Ratios" },
                }}
                itemKeys={{
                    "order_number": ["order_number"],
                    "asn_type": ["asn_type"],
                    "box_count" : ["box_count"],
                    "sku": [
                        // Render the sku and ratio chips here
                        (state, functions, data) => renderSkuChips(data),
                    ],
                }}
                submitHandler={(item) => {
                    if(!selectedBoxTemplate?.[item?.box_id]){
                        props.submitHandler(item);
                    }
                }}
                isListItemDisabled = {({ item }) => {
                            return selectedBoxTemplate?.[item?.box_id]
                        }}            
                api={{
                    reduxState: "generalStore",
                    apiName: "getTableComponentSecondList",
                    apiPayload: (params) => {
                        return {
                            "displayName": "VENDOR_BOX_SKU_RATIO_TEMPLATE",
                            "pageSize": "10",
                            "shipmentPage": "1",
                            "pageNo": params.currentPage || 1,
                            "filter": {
                                "order_number": props?.orderNumber || "",
                                "asn_type": props.shipmentPackingType,
                            },
                            "search": params.currentSearch || "",
                            "apiUrl": "/purchase/order/get/all/box/template",
                            "baseUrl": CONFIG.SM_BACKEND_BASE_URL
                        }
                    },
                    apiExtraHeaders: getPermissionKey("purchase", "poconfig", "boxtemplate", "view"),
                    getMaxPage: (states, fucntions, response) => {
                        return response?.maxPage || 1;
                    },
                }}
                getListData={(data) => data?.resource?.map(item => ({ ...item, })) || []}
            />
        </div>
    )
}

export default CreateBoxTemplateDropdown